import { render, staticRenderFns } from "./LabBase.vue?vue&type=template&id=5688bae4&"
import script from "./LabBase.vue?vue&type=script&lang=js&"
export * from "./LabBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports